<template>
	<div class="business-pay-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.business_pay_page_v2.sec_01.title.one') }}<br />
					<strong>{{
						$t('new_ui.business_pay_page_v2.sec_01.title.two')
					}}</strong>
				</h2>
				<p>
					{{ $t('new_ui.business_pay_page_v2.sec_01.desc.one') }}<br />
					{{ $t('new_ui.business_pay_page_v2.sec_01.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.business_pay_page_v2.sec_01.btn.one') }}
					</a>
					<a href="/service/cs/cs" class="btn-type-02">
						{{ $t('new_ui.business_pay_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-14">
			<div class="container-box">
				<p>{{ $t('new_ui.business_pay_page_v2.sec_14.desc.one') }}</p>
				<a href="/service/cs/cs" class="btn-type-03">
					{{ $t('new_ui.business_pay_page_v2.sec_14.btn') }}
					<img :src="img.iconArrowRightCircle" alt="" />
				</a>
			</div>
		</section>
		<section class="sec-03">
			<div class="container-box">
				<div class="title-box">
					<h3>
						{{ $t('new_ui.business_pay_page_v2.sec_03.title.one') }}
					</h3>
					<p>{{ $t('new_ui.business_pay_page_v2.sec_03.desc.one') }}</p>
				</div>
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.business_pay_page_v2.sec_03.one.title.one') }}
						</h3>
						<p>
							{{ $t('new_ui.business_pay_page_v2.sec_03.one.desc.one') }}
						</p>
						<a @click="showComingSoon" class="btn-type-02">
							{{ $t('new_ui.business_pay_page_v2.sec_03.one.btn.one') }}
						</a>
					</div>
					<div class="img-box">
						<img :src="img.imgBusinessPaySec0301" alt="" />
					</div>
				</div>
				<div class="txt-img-box">
					<div class="img-box">
						<img :src="img.imgBusinessPaySec0302" alt="" />
					</div>
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.business_pay_page_v2.sec_03.two.title.one') }}
						</h3>
						<p>
							{{ $t('new_ui.business_pay_page_v2.sec_03.two.desc.one') }}
							<br />
							{{ $t('new_ui.business_pay_page_v2.sec_03.two.desc.two') }}
						</p>
						<a @click="showComingSoon" class="btn-type-02">
							{{ $t('new_ui.business_pay_page_v2.sec_03.two.btn.one') }}
						</a>
					</div>
				</div>
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.business_pay_page_v2.sec_03.three.title.one') }}
							<br />
							{{ $t('new_ui.business_pay_page_v2.sec_03.three.title.two') }}
						</h3>
						<p>
							{{ $t('new_ui.business_pay_page_v2.sec_03.three.desc.one') }}
						</p>
						<a href="/auth/register" class="btn-type-02">
							{{ $t('new_ui.business_pay_page_v2.sec_03.three.btn.one') }}
						</a>
					</div>
					<div class="img-box">
						<img :src="img.imgBusinessPaySec0303" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section class="sec-07">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.business_pay_page_v2.sec_07.title.one') }}<br />{{
						$t('new_ui.business_pay_page_v2.sec_07.title.two')
					}}
				</h3>
				<ul>
					<li>{{ $t('new_ui.business_pay_page_v2.sec_07.list.one') }}</li>
					<li>
						{{ $t('new_ui.business_pay_page_v2.sec_07.list.two.one') }}<br />
						{{ $t('new_ui.business_pay_page_v2.sec_07.list.two.two') }}<br />
						{{ $t('new_ui.business_pay_page_v2.sec_07.list.two.three')
						}}<br /><br />
						{{ $t('new_ui.business_pay_page_v2.sec_07.list.two.four') }}<br />
						{{ $t('new_ui.business_pay_page_v2.sec_07.list.two.five') }}
					</li>
				</ul>
			</div>
		</section>
	</div>
</template>

<script>
import iconArrowRightCircle from '@/assets/images/v2/icon/icon-arrow-right-circle.svg';
import imgBusinessPaySec0301 from '@/assets/images/v2/img-business-pay-sec-03-01.png';
import imgBusinessPaySec0302 from '@/assets/images/v2/img-business-pay-sec-03-02.png';
import imgBusinessPaySec0303 from '@/assets/images/v2/img-business-pay-sec-03-03.png';

export default {
	data: () => {
		return {
			img: {
				iconArrowRightCircle,
				imgBusinessPaySec0301,
				imgBusinessPaySec0302,
				imgBusinessPaySec0303,
			},
		};
	},
	methods: {
		showComingSoon() {
			alert(this.$t('new_ui.business_pay_page_v2.common.coming_soon'));
		},
	},
};
</script>
